import _ from 'lodash';
import { OutputChannels, useLocale } from 'src/modules/locale';

/**
 * Convert invalid object types into strings. This is a bug with getLocalizedObject()
 * @param channel (optional) Filters results by an output channel
 */
const cleanupProducts = (products: any[], channel?: OutputChannels) => {
  const cleanupProps = (props: any) => {
    return _.map(props, (prop) => {
      if (_.isObject(prop)) {
        return _.values(prop).join('');
      }

      return prop;
    });
  };

  const cleanProducts = _.map(products, (product) => ({
    ...product,
    channels: cleanupProps(product.channels),
    product_subcategories: cleanupProps(product.product_subcategories),
  }));

  // filter by output channel
  if (channel) {
    return _.filter(cleanProducts, (p) => {
      return _.includes(p.channels, channel) ? p : undefined;
    });
  }

  // don't filter by output channel
  return cleanProducts;
};

export const useChannelFilteredData = (results: any[]) => {
  const { outputChannel } = useLocale();

  return _.filter(results, (r) => {
    return _.includes(r?.channels, outputChannel) ? r : undefined;
  });
};

export default cleanupProducts;
